var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#575757",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.153 15.342l.42-.43c.28-.284.28-.746 0-1.03L3.579 8.81h22.374c.395 0 .715-.327.715-.73v-.607c0-.403-.32-.73-.715-.73H3.578l4.996-5.07c.279-.284.279-.746 0-1.03l-.421-.43c-.279-.285-.731-.285-1.01 0L.209 7.262c-.279.285-.279.747 0 1.031l6.934 7.049c.279.285.731.285 1.01 0z",
    transform: "translate(-163 -187) translate(80 159) translate(83 28) translate(2.667 8.159)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackThin);
export default __webpack_public_path__ + "static/media/arrow-back-thin.69a6712febd78f75866aea99a291739a.svg";
export { ForwardRef as ReactComponent };